import $models from '@/models'
import $store from '@/store'
import util from "@/util";
import storage from "@/generic_api/firebase/storage";

const $taskMeta = $models.taskMeta;
const $taskDetails = $models.taskDetails;
// const $taskNames = $models.taskNames;
const $taskChecklistItem = $models.taskChecklistItem;
// const $taskComment = $models.taskComment;
// const $taskSubscription = $models.taskSubscription;
// const $taskSession = $models.taskSession;

export const MAGIC_UID_TEAM = 'TEAM'; // TEAM? / _BACKLOG?

const team_id = 'core'; // TODO !!!

/* =========================== Helper functions ============================= */

const log = (...args) => { console.log("[API:task]", ...args) };

// TODO: getter

export function get_last_sortidx_for_tasks(goal_id, user_id, lane_id) {
  let task_meta_list = $taskMeta
              .with({ goalId: goal_id, uid: user_id })
              .getList()
              .asArrayFilteredBy('laneId', lane_id)

  let array = task_meta_list.items;

  if ( array.length > 0 ) {
    let last_sort_idx = array.reduce((p, v) => ( p.sortidx  > v.sortidx  ? p : v ) )
    return last_sort_idx.sortidx + 100;
  } else {
    return 100;
  }

  /*
  let tasks = $store.getters['goal/get_tasks_flat_with_parent'](goal_id, lane_id);
  if (!tasks || tasks.length === 0) {
    return 100;
  } else {
    let last_task = tasks.reduce((p, v) => (p.sortidx > v.sortidx ? p : v));
    return last_task.sortidx + 100;
  }
  */
}

export function get_last_sortidx_for_checklist_item(goal_id, task_id) {
  let checklist_items = $store.getters['goal/checklist_items_by_goal_id_and_task_id'](goal_id, task_id);
  if (!checklist_items || checklist_items.length === 0) {
    return 100;
  } else {
    let last_checklist_items = checklist_items.reduce((p, v) => (p.sortidx > v.sortidx ? p : v));
    return last_checklist_items.sortidx + 100;
  }
}

// -----------------------------------------------------------------------------

/*
  add a task
  TODO: parent_id -> lane_id
*/
export function task_create_user({ goal_id, parent_id, member_id, data }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !parent_id ) {
    throw new Error('Invalid parent_id', parent_id)
  }

  if ( parent_id === '_UNASSIGNED' ) { // raus?
    parent_id = null;
  }

  if ( !member_id ) {
    // Supports adding tasks to other user!
    /* No user ID means we create the task for the current user */
    member_id = $store.getters["user/userAuth"].id;
  }

  data = data || {};
  data.sortidx   = data.sortidx || get_last_sortidx_for_tasks(goal_id, member_id, parent_id);
  data.laneId    = parent_id;
  data.userId    = member_id;

  log("task_create: submitting payload", goal_id, member_id, data);

  return $taskMeta
         .with({ goalId: goal_id, uid: member_id })
         .add(data)
}

// -----------------------------------------------------------------------------

export function task_create_backlog({ goal_id, parent_id, data }) { // <OK>
  return task_create_user({
    goal_id,
    parent_id,
    user_id: MAGIC_UID_TEAM,
    ...data
  })
}

// -----------------------------------------------------------------------------

/*
 * Update task
 */
export function task_update({ goal_id, task_id, member_id, data }) { // <OK>
  log("task_update", task_id, data);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  /* Convert 'Date' to firestore 'Timestamp' */
  if ( 'deadline' in data && data.deadline !== null ) {
    data.deadline = data.deadline.toFirestore();
  }

  log("task_update: submitting payload", data);
  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  // TOOD: Support adding tasks to other user!

  return $taskMeta
         .with({ goalId: goal_id, uid: member_id })
         .update(task_id, data)
}

// -----------------------------------------------------------------------------

/*
  Update task name
  */
export function task_set_title({ task_id, name, goal_id, member_id }) { // <OK>
  log("task_set_title", task_id, name);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  // TOOD: Support adding tasks to other user!

  // TODO: TEAM TASK !!!! also use task_update

  log("task_set_title: submitting payload", { name });
  return $taskMeta
         .with({ goalId: goal_id, uid: member_id })
         .update(task_id, { name })
}

// -----------------------------------------------------------------------------

/*
  move task batch
  */
export function task_move_batch({ batch, member_id, goal_id }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  //log("task_move_batch",  batch);
  return $taskMeta.with({ goalId: goal_id, uid: member_id }).reorder(batch)
}

// -----------------------------------------------------------------------------

export function task_delete({ task_id, goal_id, member_id, soft_delete = true }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( soft_delete ) {
    log("task_delete: submitting payload", { deleted: true });
  } else {
    log("task_delete: submitting payload");
  }

  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  return $taskMeta
   .with({ goalId: goal_id, uid: member_id })
   .remove(task_id, soft_delete)
   .then(() => {
    if ( !soft_delete ) {
      return $taskDetails.with({
        goalId: goal_id,
        uid:    member_id,
      }).remove( task_id )
    }
  })
}

// -----------------------------------------------------------------------------
export function task_restore({ task_id, goal_id, member_id }) {
  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( !util.isValidId( member_id ) ) {
    throw new Error('Invalid member_id', member_id)
  }

  return $taskMeta
   .with({ goalId: goal_id, uid: member_id })
   .restore(task_id)
}

// -----------------------------------------------------------------------------
export function task_create_checklist_item({ goal_id, task_id, data }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  data = data || {};
  data.sortidx = data.sortidx || get_last_sortidx_for_checklist_item(goal_id, task_id);

  console.log("task_create_checklist_item", data);

  // "/goal/{goalId}/user_list/{uid}/task_details/{taskId}/checklist/*",
  return $taskChecklistItem
         .with({ goalId: goal_id, taskId: task_id }) // todo uid?
         .add(data)
}

// -----------------------------------------------------------------------------

export function task_update_checklist_item({ goal_id, task_id, item_id, data }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( !util.isValidId( item_id ) ) {
    throw new Error('Invalid item_id', item_id)
  }

  console.log("task_update_checklist_item", goal_id, task_id, item_id, data);
  return $taskChecklistItem
         .with({ goalId: goal_id, taskId: task_id }) // todo uid?
         .update(item_id, data)
}

// -----------------------------------------------------------------------------

/*
 *
 * Input:
 * Batch should be '[{ id: id1, sortidx: 1 }, { id: id2 sortidx: 2 }, ...]'
 * or
 * [id1, id2, ...]
 */
export function task_move_checklist_items_batch({ goal_id, task_id, batch }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  return $taskChecklistItem
         .with({ goalId: goal_id, taskId: task_id }) // todo uid?
         .reorder( batch )
}

// -----------------------------------------------------------------------------

export function task_rem_checklist_item({ goal_id, task_id, item_id }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( !util.isValidId( item_id ) ) {
    throw new Error('Invalid item_id', item_id)
  }

  console.log("task_rem_checklist_item", goal_id, task_id, item_id);
  return $taskChecklistItem
         .with({ goalId: goal_id, taskId: task_id }) // todo uid?
         .remove(item_id)
}

// -----------------------------------------------------------------------------

export function task_set_done({ goal_id, task_id, member_id, task_done }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  // return $taskDetails
  return $taskMeta
         .with({ goalId: goal_id, uid: member_id })
         .update( task_id, { done : task_done });
}

// -----------------------------------------------------------------------------

export function task_assign_to_lane({ goal_id, lane_id, new_member_id, old_member_id, task_id }) {
  return task_assign_to_commitment({ goal_id, commitment_id: lane_id, new_member_id, old_member_id, task_id });
}

export function task_assign_to_commitment({ goal_id, commitment_id, new_member_id, old_member_id, task_id }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( !util.isValidId( new_member_id ) && new_member_id !== MAGIC_UID_TEAM ) {
    throw new Error('Invalid new_member_id', new_member_id)
  }

  if ( !util.isValidId( old_member_id ) && old_member_id !== MAGIC_UID_TEAM  ) {
    throw new Error('Invalid old_member_id', old_member_id)
  }
  // member_id = member_id || $store.getters["user/userAuth"].id;

  if ( new_member_id === MAGIC_UID_TEAM ) {
    // TODO
  }

  /*
  if ( commitment_id === '_UNASSIGNED' ) {
    commitment_id = null;
  } else if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid lane_id', commitment_id)
  }
  */
  console.log("[task_assign_to_commitment] new_member_id", new_member_id, "old_member_id", old_member_id);

  let movePromise = Promise.resolve()
  if ( new_member_id !== old_member_id ) {
    /* Check if task changed owner */
    movePromise = $taskMeta
      .with({ goalId: goal_id })
      .move(task_id, { uid: old_member_id }, { uid: new_member_id })
      .then(() => {

        // TODO: testen...
        return $taskDetails
          .with({ goalId: goal_id })
          .move(task_id, { uid: old_member_id }, { uid: new_member_id })
      })
  }

  // let data = { 'commitmentId': commitment_id };
  let data = {
    laneId: commitment_id,
  };
  return movePromise.then(() => {
    console.log("[task_assign_to_commitment] task moved successfully");
    task_update({ goal_id, task_id, member_id: new_member_id, data })
  });
}

// -----------------------------------------------------------------------------

export function task_assign_to_goal({
  src_goal_id,
  dst_goal_id,
  src_commitment_id,  // not required
  dst_commitment_id,
  src_member_id,
  dst_member_id,
  task_id,
  copy = false
}) {

  if ( !util.isValidId( src_goal_id ) ) {
    throw new Error('Invalid src_goal_id', src_goal_id)
  }

  if ( !util.isValidId( dst_goal_id ) ) {
    throw new Error('Invalid dst_goal_id', dst_goal_id)
  }

  if ( !util.isValidId( src_commitment_id ) && !src_commitment_id === null) {
    throw new Error('Invalid src_commitment_id', src_commitment_id)
  }

  if ( !util.isValidId( dst_commitment_id ) ) {
    throw new Error('Invalid dst_commitment_id', dst_commitment_id)
  }

  if ( !util.isValidId( dst_member_id ) && dst_member_id !== MAGIC_UID_TEAM ) {
    throw new Error('Invalid dst_member_id', dst_member_id)
  }

  if ( !util.isValidId( src_member_id ) && src_member_id !== MAGIC_UID_TEAM  ) {
    throw new Error('Invalid src_member_id', src_member_id)
  }

  if ( src_goal_id === dst_goal_id ) {
    // TODO: Kann das raus?
    throw new Error('Source and destination goal can not be the same')
  }

  if ( src_commitment_id === dst_commitment_id ) {
    throw new Error('Source and destination commitment can not be the same')
  }

  let contextA = { goalId: src_goal_id, uid: src_member_id }
  let contextB = { goalId: dst_goal_id, uid: dst_member_id }

  console.log("[task_assign_to_goal] contextA", contextA, "contextB", contextB,
    "dst_commitment_id", dst_commitment_id, "task_id", task_id);

  // INFO: It is possible to copy here too! (just add a checkbox to prompt)
  // TODO: Update sortidx?

  let options = copy ? { keepOriginal: true, keepId: true } : {}; // KeepId must be true for now!

  return $taskMeta
    .move(task_id, contextA, contextB, options)
    .then(() => {
      return $taskDetails
        .move(task_id, contextA, contextB, options)
    }).then(() => {
      // task_update({ goal_id, task_id, member_id: new_member_id, data })

      return $taskMeta
        .with( contextB )
        .update( task_id, { laneId: dst_commitment_id } )

    }).then(() => {
      return task_id;
    })
}

// -----------------------------------------------------------------------------

export function task_duplicate({ goal_id, member_id, task_id }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( member_id ) ) {
    throw new Error('Invalid member_id', member_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  // TODO: Careful: This won't generate new checklist item IDs

  return $taskMeta
    .with({ goalId: goal_id, uid: member_id })
    .copy(task_id, {}, {})
    .then(new_task_id => {
      console.log("new_task_id", new_task_id)
      return $taskDetails
        .with({ taskId: new_task_id, goalId: goal_id, uid: member_id })
        .copy(task_id, {}, {})
      // TODO: This syntax can be improved
    })
}

// -----------------------------------------------------------------------------

export function task_drop_file({ goal_id, task_id, member_id, file }) {

  console.log("[task_drop_file]", goal_id, task_id, member_id, file);

  // TODO: Also allow file list
  // TODO: Maximum of 5 files
  // TODO: Check if file is a valid file
  // TODO: Validate input MIME type
  // TODO: Generate UUID from a attachment store / create schema for attachment

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( task_id ) ) {
    throw new Error('Invalid task_id', task_id)
  }

  if ( !file || !file.constructor || !file.constructor.name === 'File' ) { // TODO: might not work in production
    throw new Error('Got invalid file', file)
  }

  if ( !member_id ) {
    console.warn("No member id", member_id)
  }
  member_id = member_id || $store.getters["user/userAuth"].id;

  let attachment_id = $taskMeta._get_uid(); // < TODO

  // let fileRef = storage.child(`task_attachments/${team_id}/${goal_id}`); // < Bug security rules
  // let fileRef = storage.child('task_attachments/${team_id}/');

  let fileRef = storage.child(`task_attachments/${team_id}/${goal_id}/${task_id}__${attachment_id}`);

  return new Promise((resolve, reject) => {
    fileRef.put(file).then(snapshot => {
      console.log("[task_drop_file]", "Got snapshot", snapshot)

      snapshot.ref.getDownloadURL().then((url) => {

        console.log("[task_drop_file]", "Got URL", url);

        let data = {
          ['attachments/' + attachment_id]: url
          // TODO: Filename
          // TODO: Size
          // TODO: Update accumulative file size counter
        }
        task_update({ goal_id, task_id, member_id, data }).then(() => {
          resolve( url )
        }).catch(reject);
      }).catch(reject);
    }).catch(reject);
  });
}

// -----------------------------------------------------------------------------
export function task_file_get_metadata({ goal_id, task_id, attachment_id }) {

  let fileRef = storage.child(`task_attachments/${team_id}/${goal_id}/${task_id}__${attachment_id}`);

  // let download_url = await fileRef.getDownloadURL();

  // Get metadata properties
  return fileRef.getMetadata().then(metadata => {
    return metadata;
  }).catch(error => {
    console.warn("task_file_get_metadata failed", error)
  });
}

// -----------------------------------------------------------------------------
export function task_delete_file({ goal_id, task_id, member_id, attachment_id }) {

  if ( !util.isValidId( attachment_id ) ) {
    throw new Error('Invalid attachment_id', attachment_id)
  }

  // Create a reference to the file to delete
  let fileRef = storage.child(`task_attachments/${team_id}/${goal_id}/${task_id}__${attachment_id}`);
  console.log("fileRef", fileRef);

  // Delete the file
  return new Promise((resolve, reject) => {
    return fileRef.delete().then(() => {

      let data = {
        ['attachments/' + attachment_id]: null
        // TODO: Update accumulative file size counter
      }
      task_update({ goal_id, task_id, member_id, data }).then(() => {
        resolve()
      }).catch(reject);
    }).catch(reject)
  });
}
// -----------------------------------------------------------------------------
